import { render } from "./BookContent.vue?vue&type=template&id=58743188&scoped=true"
import script from "./BookContent.vue?vue&type=script&lang=js"
export * from "./BookContent.vue?vue&type=script&lang=js"

import "./BookContent.vue?vue&type=style&index=0&id=58743188&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58743188"]])

export default __exports__